module.exports = __webpack_public_path__ + "static/step-3-b8d1f4b423edf8acc96b4ae7420ef9f1.svg";